import React from 'react';
import {
  Component,
  PuzzleTooltip as TpTooltip,
  WithTooltip,
  PuzzleButton
} from "puzzle";
import { Container } from "puzzle";
import { getUrlWithParams } from "../../util/Util";

type DRAWER_COMPONENT_PROPS = {
  submissionData: any,
  updateDrawerState: (detach: any) => void,
}


type DRAWER_COMPONENT_STATE = {}

class DrawerHeader extends Component<DRAWER_COMPONENT_PROPS, DRAWER_COMPONENT_STATE> {
  tooltip: any;
  tooltipRefDetach: any;

  /**
   * Handle close drawer on X button
   */
  handleClose = () => {
    this.dispatch('handleQuoteChangesCheckOnCloseDrawer');
  }

  /**
   * Adds taskDetails to drawer header
   */
  taskDataRender = (): JSX.Element => {
    const {
      batchName,
      phaseName,
      targetLanguage,
    } = this.props.submissionData;
    const tooltipTitle = `${batchName} | ${targetLanguage.value} | ${phaseName}`

    return <Container
      className={'tp-text-semibold tp-color-accent tp-font-size-md k-text-ellipsis'}
    >
      <WithTooltip
        context={this}
        title={tooltipTitle}
        htmlTag={'span'}
      >
          <span title={tooltipTitle}>
            {`${batchName} | ${targetLanguage.value} | ${phaseName}`}
          </span>

      </WithTooltip>
    </Container>
  }

  /**
   * Copy link
   */
  copyUrl = () => {
    const { submissionId } = this.props.submissionData;
    if (submissionId) {
      let urlToCopy = getUrlWithParams(submissionId);
      this.dispatch('copy_URI', '', { urlToCopy })
    }
  };


  renderBody() {
    const {
      submissionId,
      submissionName,
      taskId = undefined
    } = this.props.submissionData;
    const copyLinkText = taskId ? 'SRL-copyLinkSupplier' : 'SRL-copyLink';
    return (
      <div
        draggable={true}
        onDragEnd={this.props.updateDrawerState.bind(this, true)}
        className={'tp-drawer-header-content'}
      >
        <div className={'tp-drawer-header-information'}>
          <h3 className="k-text-ellipsis tp-font-size-md">
            <span className={'tp-drawer-header-submission-id'}>{submissionId}</span>
            <Container
              alignItemsCenter
              aria-hidden="true"
              displayInlineFlex
            >
              |
            </Container>
            <WithTooltip
              context={this}
              title={submissionName}
              htmlTag={'span'}
            >
              <span className='tp-drawer-header-submission-name' title={submissionName}>
                {submissionName}
              </span>
            </WithTooltip>
          </h3>
          {taskId && this.taskDataRender()}
          <PuzzleButton
            aria-label={this.translate('SRL-openInNew')}
            titleText={this.translate('SRL-openInNew')}
            fillMode="flat"
            themeColor={'primary'}
            iconClass={"tp-icon tp-open_in_new"}
            onClick={this.props.updateDrawerState.bind(this, true)}
            tooltipPosition={'right'}
            withTooltip
          />
          <PuzzleButton
            aria-label={this.translate(copyLinkText)}
            titleText={this.translate(copyLinkText)}
            fillMode="flat"
            themeColor={'primary'}
            iconClass={"tp-icon tp-share"}
            onClick={this.copyUrl}
            tooltipPosition={'right'}
            withTooltip
          />
        </div>
        <Container
          alignItemsCenter
          justifyContentEnd
          displayFlex
          className="tp-drawer-header-actions"
        >
          <PuzzleButton
            id={'close_drawer'}
            aria-label={this.translate('SRL-closeDrawer')}
            fillMode="flat"
            iconClass={"tp-icon tp-x"}
            onClick={this.handleClose}
          />
        </Container>
        <TpTooltip
          anchorElement={'target'}
          ref={(el: any) => this.tooltip = el}
          openDelay={1000}
          position="bottom"
        />
      </div>
    );
  }
}

export default DrawerHeader;
